module.exports = __webpack_public_path__ + "img/widget_icon.acdfb122.svg";